module.exports = __webpack_public_path__ + "f61a3cdafee58d829e752da0c7de0d48.png";